const INITIAL_STATE = {
    approvedpayments: []
 };
 
  const paymentReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
      case "resetpayments":
         return {
          ...INITIAL_STATE
           };
       case "addapprovedpayment":
         return {
             ...state,
             approvedpayments: state.approvedpayments.concat(action.payload),
           };
       case "undoapprovedpayment":
        const undoindex = state.approvedpayments.indexOf(action.payload);
        const arrApprovedpaymentsUndo = state.approvedpayments.map(item => item);
        arrApprovedpaymentsUndo.splice(undoindex,1);         
         return {
           ...state,
           approvedpayments: arrApprovedpaymentsUndo
           };
       default:
         return state;
     }
   };
 
   export default paymentReducer;